import { type ethers } from "ethers";

export type GasObjectType = {
  maxPriorityFeePerGas?: bigint;
  maxFeePerGas?: bigint;
  gasPrice?: bigint;
};

export const getEIP1559GasPrice = async (baseFeePerGas: bigint) => {
  const priorityFee = baseFeePerGas / 2n;
  const maxFeePerGas = baseFeePerGas + priorityFee;

  return {
    priorityFee,
    maxFeePerGas,
  };
};

export const getGasObjectFromProvider = async (
  provider: ethers.JsonRpcProvider | ethers.JsonRpcApiProvider,
) => {
  const block = await provider.getBlock("latest");

  const result: GasObjectType = {};

  if (!block?.baseFeePerGas) {
    const feeData = await provider.getFeeData();
    result.gasPrice = feeData.gasPrice ?? 0n;
    // result.gasPrice /= 2n;
  } else {
    const { priorityFee, maxFeePerGas } = await getEIP1559GasPrice(
      block.baseFeePerGas,
    );

    result.maxPriorityFeePerGas = priorityFee;
    result.maxFeePerGas = maxFeePerGas;
  }

  return result;
};

export const calulateAndUpdateGasPrice = async (
  provider: ethers.JsonRpcProvider,
  tx: ethers.TransactionRequest,
) => {
  const gasObject = await getGasObjectFromProvider(provider);

  tx = {
    ...tx,
    ...gasObject,
  };

  return tx;
};
